import { bool, node } from 'prop-types';
import React, { PureComponent } from 'react';
import { ScrollView, View } from 'react-native';

import { LAYOUT } from 'reactor/common';
import styles from './Content.style';

class Content extends PureComponent {
  static propTypes = {
    aside: bool,
    children: node,
    fullWide: bool,
  };

  static defaultProps = {
    aside: false,
    children: undefined,
    fullWide: false,
  };

  render() {
    const { props: { aside, children, fullWide } } = this;
    const { VIEWPORT: { LANDSCAPE } } = LAYOUT;

    return (
      <ScrollView
        contentContainerStyle={[
          styles.container,
          aside && LANDSCAPE && styles.aside,
          !aside && styles.noAside,
          !LANDSCAPE && styles.containerPortrait,
        ]}
      >
        <View style={[styles.content, !fullWide && styles.wrapper]}>
          { children }
        </View>
      </ScrollView>
    );
  }
}

export default Content;
